import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { deleteDiagramItem } from '../actions/entry';
import LineLastNode from '../components/Diagram/LineLastNode';

const makeMapStateToProps = (state, { id, isConnectable }) => {
  return {
    id,
    isConnectable,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onDeleteNode: deleteDiagramItem,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(LineLastNode);
